import React, { useState, useEffect, useRef, useCallback } from "react"
import Page from "@smpu-web/globalmodules/page"
import DataTable, { DateTableHandleType } from "@bappweb/datatable"
import Message from "@bappweb/message"
import { useAppSelector } from "../../config/hook"
import { useDeviceSize, Sizes } from "@bappweb/provider"
import "./assets/style.scss"

const Result = ({items}) => {
  let size = useDeviceSize()
  size = size === undefined ? Sizes.md : size
  const isSmallerThanMd = size < Sizes.md ? true : false

  const refTable = useRef<DateTableHandleType>(null)

  const gridOptions = {
    pageSize: isSmallerThanMd && (items?.length ?? 0) > 5 ? Math.ceil((items?.length || 10) / 2) : 5,
    pageAble: true,
    noDataMessage: "Hesap bilgisi bulunamadı.",
    virtualization: false,
    virtualizationLoadSize: 250,
    className: 'datatable',
    scrollHeight: "600px",

    columns: [
      { title: "Şube Kodu", prop: "subeKodu", sortable: false },
      { title: "Şube Adı", prop: "subeAdi", sortable: false },
      { title: "Hesap Tipi", prop: "hesapTipi", sortable: false },
      { title: "Hesap Türü", prop: "hesapTuru", sortable: false },
      { title: "Değer", prop: "degerAraligi", sortable: false },
      { title: "Birim", prop: "paraCinsi", sortable: false },
      { title: "Son İşlem Tarihi", prop: "sonIslemTarihi", sortable: false },
      { title: "Banka", prop: "banka", sortable: false },
      { title: "Ad Soyad", prop: "adSoyad", sortable: false, defaultContent: "-"  },
      { title: "Unvan", prop: "unvan", sortable: false, defaultContent: "-" },
      { title: "Doğum Tarihi", prop: "dogumTarihi", sortable: false, defaultContent: "-"  },
    ]
  }

  useEffect( () => {
    const mutableItems : any[] = [];

    if (items.length > 0){
      for (let i = 0; i < items.length; i++){
        let newItem = {
          subeKodu: items[i].subeKodu,
          subeAdi: items[i].subeAdi,
          hesapTipi: items[i].hesapTipi,
          hesapTuru: items[i].hesapTuru,
          banka : items[i].banka,
          sonIslemTarihi: items[i].sonIslemTarihi,
          paraCinsi: items[i].paraCinsi,
          degerAraligi : items[i].degerAraligi,
          adSoyad: items[i].adSoyad,          
          unvan : items[i].unvan,
          dogumTarihi: items[i].dogumTarihi
        }
        mutableItems.push(newItem)
      }
    }
    refTable.current?.loadWithDataArray(mutableItems)
    
  }, [items])

  return (
    <Page>
      {items && items.length > 0 &&
        <>
          <Message className="form-msg">{"Toplam Kayıt Sayısı : " + items.length}</Message>
          <DataTable ref={refTable} gridOptions={gridOptions} />
        </>
      }
    </Page>
  )
}

export default Result
